import { jsx as _jsx } from "react/jsx-runtime";
import { useFormContext } from "react-hook-form";
import { QuantityRadioGroup, SticksFormStepSection } from "@jti/ui";
import { QuantityGroupTitle } from "../../../../../../aem-components/product-details/components/SticksForm/components/QuantityGroup/components";
import styles from "@rip/aem-components/product-details/components/SticksForm/SticksForm.module.scss";
const QUANTITY_GROUP_NAME = "quantity";
const MAX_ALLOWED_PACKS_QUANTITY = 5;
const MAX_ALLOWED_CARTONS_QUANTITY = 3;
export const QuantityGroup = ({ step, onChange }) => {
    const { watch, register } = useFormContext();
    const packagingPreference = watch("packagingPreference");
    const registerProps = register(QUANTITY_GROUP_NAME, { onChange });
    return (_jsx(SticksFormStepSection, { title: _jsx(QuantityGroupTitle, { step: step }), className: styles.stepSection, "data-testid": "quantity-selection-step", children: _jsx(QuantityRadioGroup, { registerProps: registerProps, groupName: QUANTITY_GROUP_NAME, numberOfElements: packagingPreference === "single_packs" ? MAX_ALLOWED_PACKS_QUANTITY : MAX_ALLOWED_CARTONS_QUANTITY, type: packagingPreference === "single_packs" ? "packs" : "cartons" }) }));
};
//# sourceMappingURL=QuantityGroup.js.map